import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contentPanel", "filterButtons"]
  static values = {
    platform: { type: String, default: "all" },
    status: { type: String, default: "all" }
  }

  connect() {
    this.setupDragAndDrop()
  }

  setupDragAndDrop() {
    // Make content items draggable
    const items = this.element.querySelectorAll("[data-draggable='true']")
    items.forEach(item => {
      item.setAttribute("draggable", "true")
      item.addEventListener("dragstart", this.handleDragStart.bind(this))
      item.addEventListener("dragend", this.handleDragEnd.bind(this))
    })

    // Make day cells drop targets
    const dayCells = this.element.querySelectorAll("[data-drop-target='true']")
    dayCells.forEach(cell => {
      cell.addEventListener("dragover", this.handleDragOver.bind(this))
      cell.addEventListener("drop", this.handleDrop.bind(this))
      cell.addEventListener("dragleave", this.handleDragLeave.bind(this))
    })
  }

  handleDragStart(event) {
    const contentId = event.target.dataset.contentId
    event.dataTransfer.setData("text/plain", contentId)
    event.target.classList.add("opacity-50")
  }

  handleDragEnd(event) {
    event.target.classList.remove("opacity-50")
  }

  handleDragOver(event) {
    event.preventDefault()
    event.currentTarget.classList.add("bg-[#C4A484]/10")
  }

  handleDragLeave(event) {
    event.currentTarget.classList.remove("bg-[#C4A484]/10")
  }

  handleDrop(event) {
    event.preventDefault()
    event.currentTarget.classList.remove("bg-[#C4A484]/10")

    const contentId = event.dataTransfer.getData("text/plain")
    const newDate = event.currentTarget.dataset.date

    if (contentId && newDate) {
      this.rescheduleContent(contentId, newDate)
    }
  }

  async rescheduleContent(contentId, newDate) {
    try {
      const response = await fetch(`/admin/content_items/${contentId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ content_item: { scheduled_at: newDate } })
      })

      if (response.ok) {
        // Reload the calendar to show updated positions
        window.location.reload()
      }
    } catch (error) {
      console.error("Failed to reschedule content:", error)
    }
  }

  filterByPlatform(event) {
    const platform = event.currentTarget.dataset.platform
    this.platformValue = platform

    this.updateFilterButtons(event.currentTarget, "platform")
    this.applyFilters()
  }

  filterByStatus(event) {
    const status = event.currentTarget.dataset.status
    this.statusValue = status

    this.updateFilterButtons(event.currentTarget, "status")
    this.applyFilters()
  }

  updateFilterButtons(activeButton, type) {
    const buttons = this.element.querySelectorAll(`[data-filter-type="${type}"]`)
    buttons.forEach(btn => {
      btn.classList.remove("bg-[#C4A484]", "text-white")
      btn.classList.add("bg-[#F5F3F0]", "text-[#8C8C8C]")
    })
    activeButton.classList.remove("bg-[#F5F3F0]", "text-[#8C8C8C]")
    activeButton.classList.add("bg-[#C4A484]", "text-white")
  }

  applyFilters() {
    const items = this.element.querySelectorAll("[data-content-item]")
    items.forEach(item => {
      const itemPlatform = item.dataset.platform
      const itemStatus = item.dataset.status

      const platformMatch = this.platformValue === "all" || itemPlatform === this.platformValue
      const statusMatch = this.statusValue === "all" || itemStatus === this.statusValue

      if (platformMatch && statusMatch) {
        item.classList.remove("hidden")
      } else {
        item.classList.add("hidden")
      }
    })
  }

  showContentDetail(event) {
    const contentId = event.currentTarget.dataset.contentId
    const panel = this.contentPanelTarget

    // Fetch content details via AJAX
    fetch(`/admin/content_items/${contentId}/preview`, {
      headers: { "Accept": "text/html" }
    })
    .then(response => response.text())
    .then(html => {
      panel.innerHTML = html
      panel.classList.remove("hidden")
    })
  }

  closePanel() {
    if (this.hasContentPanelTarget) {
      this.contentPanelTarget.classList.add("hidden")
    }
  }
}
